<template>
  <div class="min-h-screen bg-white">
    <HeroGreeting />
    <div class="px-4">
      <router-view />
    </div>
    <LiveChatWidget license="19787725" @ready="onReady" />
  </div>
</template>
<script>
import HeroGreeting from "@/components/common/GreetingHeader.vue";
import { LiveChatWidget } from "@livechat/widget-vue";
import { inject, onMounted } from "vue";
export default {
  components: {
    HeroGreeting,
    LiveChatWidget,
  },
  setup() {
    const store = inject("$store");
    const onReady = () => {
      window.LiveChatWidget.call(
        "set_customer_name",
        store.state.userLogged ? store.state.userLogged : ""
      );

      window.LiveChatWidget.call("set_customer_email", "");
    };
    onMounted(() => {
      onReady();
    });
    return { onReady };
  },
};
</script>
